import classNames from "classnames";
import {Picture} from "@/shared/ui/Picture";
import {FooterSocial} from "../../model/types";
import styles from "../Footer.module.scss";

type Props = {
    socials: FooterSocial[];
    className: string;
}

export const FooterSocials = ({socials = [], className}: Props) => {
    return (
        <div className={classNames(styles.socialsContainer, className)}>
            <p className={styles.navItemTitle}>Мы в социальных сетях</p>
            <div className={styles.socialsIcons}>
                {socials.map((social) => (
                    <a
                        key={social.href}
                        href={social.href}
                        rel="noopener noreferrer"
                        className={styles.socialsIcon}
                        target={`_blank`}
                    >
                        <Picture src={social.icon} alt={social.alt} />
                    </a>
                ))}
            </div>
        </div>
    );
}
